<div class="page-container">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="page-content">

          <div *ngIf="templateslength>0">
            <div class="row">
              <div class="col-md-12">

              </div>
            </div>
            <div class="row">
              <div class="col-md-12">

              </div>
            </div>
            <table class="table table-striped table-sortable">
              <thead style="-webkit-text-fill-color: #606060;">
                <tr class="">
                  <th>
                    <a (click)="sortColumn($event,'contactName');" style="text-decoration: none;">
                      Contact
                      <span class="th-sort">
                        <span *ngIf="queryContainer.query.sortByColumn == 'contactName'">
                          <i *ngIf="!queryContainer.query.reverseSort" class="fa fa-caret-up"></i>
                          <i *ngIf="queryContainer.query.reverseSort" class="fa fa-caret-down"></i>
                        </span>
                      </span>
                    </a>
                  </th>

                  <th class="col-md-1">
                    <a (click)="sortColumn($event,'dayType');" style="text-decoration: none;">
                      Day Type
                      <span class="th-sort">
                        <span *ngIf="queryContainer.query.sortByColumn == 'dayType'">
                          <i *ngIf="!queryContainer.query.reverseSort" class="fa fa-caret-up"></i>
                          <i *ngIf="queryContainer.query.reverseSort" class="fa fa-caret-down"></i>
                        </span>
                      </span>
                    </a>
                  </th>

                  <th class="col-md-1">
                    <a (click)="sortColumn($event,'eventShow');" style="text-decoration: none;">
                      Event/Show
                      <span class="th-sort">
                        <span *ngIf="queryContainer.query.sortByColumn == 'eventShow'">
                          <i *ngIf="!queryContainer.query.reverseSort" class="fa fa-caret-up"></i>
                          <i *ngIf="queryContainer.query.reverseSort" class="fa fa-caret-down"></i>
                        </span>
                      </span>
                    </a>
                  </th>
                  <th class="col-md-1">
                    <a (click)="sortColumn($event,'sport');" style="text-decoration: none;">
                      Sport
                      <span class="th-sort">
                        <span *ngIf="queryContainer.query.sortByColumn == 'sport'">
                          <i *ngIf="!queryContainer.query.reverseSort" class="fa fa-caret-up"></i>
                          <i *ngIf="queryContainer.query.reverseSort" class="fa fa-caret-down"></i>
                        </span>
                      </span>
                    </a>
                  </th>
                  <th class="col-md-1">
                    <a (click)="sortColumn($event,'network');" style="text-decoration: none;">
                      Network
                      <span class="th-sort">
                        <span *ngIf="queryContainer.query.sortByColumn == 'network'">
                          <i *ngIf="!queryContainer.query.reverseSort" class="fa fa-caret-up"></i>
                          <i *ngIf="queryContainer.query.reverseSort" class="fa fa-caret-down"></i>
                        </span>
                      </span>
                    </a>
                  </th>
                  <th class="col-md-1">
                    <a (click)="sortColumn($event,'employeeType');" style="text-decoration: none;">
                      Employee Type
                      <span class="th-sort">
                        <span *ngIf="queryContainer.query.sortByColumn == 'employeeType'">
                          <i *ngIf="!queryContainer.query.reverseSort" class="fa fa-caret-up"></i>
                          <i *ngIf="queryContainer.query.reverseSort" class="fa fa-caret-down"></i>
                        </span>
                      </span>
                    </a>
                  </th>
                  <th>
                    <a (click)="sortColumn($event,'workState');" style="text-decoration: none;">
                      Work state
                      <span class="th-sort">
                        <span *ngIf="queryContainer.query.sortByColumn == 'workState'">
                          <i *ngIf="!queryContainer.query.reverseSort" class="fa fa-caret-up"></i>
                          <i *ngIf="queryContainer.query.reverseSort" class="fa fa-caret-down"></i>
                        </span>
                      </span>
                    </a>
                  </th>
                  <th>
                    <a (click)="sortColumn($event,'rate');" style="text-decoration: none;">
                      Rate (Day)
                      <span class="th-sort">
                        <span *ngIf="queryContainer.query.sortByColumn == 'rate'">
                          <i *ngIf="!queryContainer.query.reverseSort" class="fa fa-caret-up"></i>
                          <i *ngIf="queryContainer.query.reverseSort" class="fa fa-caret-down"></i>
                        </span>
                      </span>
                    </a>
                  </th>
                  <th class="col-md-1">
                    <a (click)="sortColumn($event,'hoursWorked');" style="text-decoration: none;">
                      Hours Worked
                      <span class="th-sort">
                        <span *ngIf="queryContainer.query.sortByColumn == 'hoursWorked'">
                          <i *ngIf="!queryContainer.query.reverseSort" class="fa fa-caret-up"></i>
                          <i *ngIf="queryContainer.query.reverseSort" class="fa fa-caret-down"></i>
                        </span>
                      </span>
                    </a>
                  </th>
                  <th class="col-md-1">
                    <a (click)="sortColumn($event,'companyCode');" style="text-decoration: none;">
                      Company Code
                      <span class="th-sort">
                        <span *ngIf="queryContainer.query.sortByColumn == 'companyCode'">
                          <i *ngIf="!queryContainer.query.reverseSort" class="fa fa-caret-up"></i>
                          <i *ngIf="queryContainer.query.reverseSort" class="fa fa-caret-down"></i>
                        </span>
                      </span>
                    </a>
                  </th>
                  <th class="col-md-1" style="padding-left: 70px;">
                    WBSE or Cost Center
                  </th>
                  <th class="col-md-1">
                    <a (click)="sortColumn($event,'glAccount');" style="text-decoration: none;">
                      GL Account
                      <span class="th-sort">
                        <span *ngIf="queryContainer.query.sortByColumn == 'glAccount'">
                          <i *ngIf="!queryContainer.query.reverseSort" class="fa fa-caret-up"></i>
                          <i *ngIf="queryContainer.query.reverseSort" class="fa fa-caret-down"></i>
                        </span>
                      </span>
                    </a>
                  </th>
                  <th class="col-md-2"></th>
                </tr>
              </thead>
              <!--</div>
              </div>

              <div class="row">
                <div class="col-md-12">-->
              <tbody ui-sortable="sortableOptions">
                <tr class="" *ngFor="let templateItem of templates ;let $index = index;trackBy: trackItem">
                  <td class="col-md-1">
                    <div style="margin:10px 10px 1px 0;" *ngIf="!templateItem.contact.id">
                      <nbc-contact-auto placeholder="Contact" listItemId="{{templateItem.id}}">
                      </nbc-contact-auto>
                    </div>
                    <div *ngIf="templateItem.id">
                      <div>
                        <a href="/scorepay/contact/{{templateItem.contact?.id ? templateItem.contact.id : 0}}"
                           target="_blank"
                           title="{{templateItem.contact?.firstName}}, {{templateItem.contact?.lastName}}">
                          <span class="item-ttl-bld btn-link" title="{{templateItem.contact?.firstName}} {{templateItem.contact?.lastName}}"
                                innerHTML="{{templateItem.contact?.firstName}} {{templateItem.contact?.lastName}}">

                          </span>
                        </a>
                      </div>
                      <div class="contact-details" *ngIf="templateItem.contact">
                        <div *ngIf="templateItem.contact.sso">SSO:  {{templateItem.contact.sso}}</div>
                        <div *ngIf="templateItem.contact.sso && templateItem.contact.perNer">PerNer:  {{templateItem.contact.perNer}}</div>
                        <div *ngIf="templateItem.contact.subBusinessSegment"
                             class="changed-by-text">{{templateItem.contact.subBusinessSegment}}</div>
                      </div>
                    </div>

                  </td>

                  <td class="col-md-1">
                    <nbc-select nbcMismatch="form-control filter-dropdown-new internal-new"
                                [(model)]="templateItem.dayType"
                                [title]="templateItem?.dayType?.description?templateItem?.dayType?.description:null"
                                name="dayType"
                                [source]="dayTypes"
                                value="id"
                                display="description"
                                placeHolderDisplay="Select"
                                placeHolderValue="-1"
                                (change)="saveOnChange(templateItem)">
                    </nbc-select>
                  </td>

                  <td>
                    <div style="margin:10px 10px 1px 0;">
                      <input class="form-control event-search"
                             maxlength="100"
                             type="text"
                             name="eventShow"
                             [(ngModel)]="templateItem.eventShow"
                             (blur)="saveOnChange(templateItem)"
                             style="width:170px;height:35px;" />

                    </div>
                  </td>
                  <td class="col-md-1">
                    <nbc-select nbcMismatch="form-control filter-dropdown-new internal-new"
                                [(model)]="templateItem.sport"
                                [title]="templateItem.sport.description?templateItem.sport.description:null"
                                name="sport"
                                [source]="sports"
                                value="id"
                                display="description"
                                placeHolderDisplay="Select"
                                placeHolderValue="-1"
                                (change)="saveOnChange(templateItem)">
                    </nbc-select>
                  </td>
                  <td class="col-md-1">
                    <nbc-select nbcMismatch="form-control filter-dropdown-new internal-new"
                                [(model)]="templateItem.network"
                                name="network"
                                [title]="templateItem.network.description?templateItem.network.description:null"
                                [source]="broadcastNetworks"
                                value="id"
                                display="description"
                                placeHolderDisplay="Select"
                                placeHolderValue="-1"
                                (change)="saveOnChange(templateItem)">
                    </nbc-select>
                  </td>
                  <td class="col-md-1">
                    <nbc-select nbcMismatch="form-control filter-dropdown-new internal-new"
                                [(model)]="templateItem.employeeType"
                                name="employeeType"
                                [title]="templateItem.employeeType.description?templateItem.employeeType.description:null"
                                [source]="employeeTypes"
                                value="id"
                                display="description"
                                placeHolderDisplay="Select"
                                placeHolderValue="-1"
                                (change)="employeeTypeValidation(templateItem);">
                    </nbc-select>
                  </td>
                  <td class="col-md-1">
                    <nbc-select nbcMismatch="form-control filter-dropdown-new internal-new"
                                [(model)]="templateItem.workState"
                                name="workState"
                                [title]="templateItem.workState && templateItem.workState.description?templateItem.workState.description:null"
                                [source]="workStates"
                                [nbcDisabled]="!(templateItem &&  templateItem.employeeType && (templateItem.employeeType.id === 'FOREIGN' || templateItem.employeeType.id === 'LOCORP'))"
                                value="id"
                                display="description"
                                placeHolderDisplay="Select"
                                placeHolderValue="-1"
                                (change)="saveOnChange(templateItem)">
                    </nbc-select>
                  </td>
                  <td class="col-md-1">
                    <div class="input-group" style="margin:10px 10px 1px 0;">
                      <div class="input-group-text">$</div>

                      <div class="float-start w-75">
                        <input class="form-control event-search d-table" id="rate-{{templateItem.id}}"
                               name="rate-{{templateItem.id}}"
                               appInputRestriction="decimalOnly"
                               placeholder="---.--"
                               type="text"
                               maxlength="9"
                               decimals="5"
                               [(ngModel)]="templateItem.rate"
                               (blur)="customFormat($index);saveOnChange(templateItem)" /> 
                      </div>
                    </div>
                  </td>
                  <!--hoursWorked-->
                  <td class="col-md-1">
                    <div class="input-group" style="margin:10px 10px 1px 0;">
                      <div class="float-start">
                        <input class="form-control numbers-only"
                               appInputRestriction="numberOnly"
                               type="text"
                               maxlength="100"
                               [(ngModel)]="templateItem.hoursWorked"
                               (blur)="saveOnChange(templateItem)" style="width: 100px;" />
                      </div>
                    </div>
                  </td>
                  <td class="col-md-1">
                    <!--{{templateItem.companyCode|json}}-->
                    <nbc-select *ngIf="companyCodes?.length>0" nbcMismatch="form-control filter-dropdown-new internal-new"
                                [(model)]="templateItem.companyCode"
                                [title]="templateItem.companyCode.description?templateItem.companyCode.description:null"
                                name="companyCode"
                                [source]="companyCodes"
                                value="description"
                                display="description"
                                placeHolderDisplay="Select"
                                placeHolderValue="Select"
                                (change)="saveOnChange(templateItem)">
                    </nbc-select>
                  </td>
                  <td class="col-md-2" style="padding:18px 30px">
                    <div class="col-md-4 float-start">
                      <div class="cost-center-selection d-flex" style="font-size:x-small">
                        <div class="col-md-3">
                          <input type="radio"
                                 class="cost-center-el"
                                 (click)="wbseorcc(templateItem,'wbse')"
                                 [checked]="!templateItem.showcc"
                                 name="costCenterType-{{templateItem.id}}" id="wbse" /> <br />
                          <span style="margin-left:-7px">WBSE</span>
                        </div>
                        <div class="col-md-8">
                          <input type="radio"
                                 class="cost-center-el"
                                 (click)="wbseorcc(templateItem,'cc')"
                                 [checked]="templateItem.showcc"
                                 name="costCenterType-{{templateItem.id}}" id="cc" /><br />
                          <span>CC</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-7 float-start">
                      <div class="input-group">
                        <div class="cost-center-input" id="wbse-{{templateItem.id}}"
                             [attr.style]="(templateItem.showcc)?'display:none':''">
                          <!--*ngIf="!templateItem.showcc"-->
                          <div id="wbse" class="required-msg hide">Required</div>
                          <div class="input-group">
                            <input type="text" class="form-control"
                                   title="{{templateItem.wbse}}"
                                   maxlength="100"
                                   name="wbse" [(ngModel)]="templateItem.wbse" />
                            <!--</input>-->
                            <span class="input-group-btn">
                              <button class="btn btn-primary btncls wbse-el" style="margin:0px !important;" (click)="selectWBSEModal(templateItem)">
                                <i class="fa fa-search"></i>
                              </button>
                            </span>
                          </div>
                        </div>

                        <div class="cost-center-input" id="costCenter-{{templateItem.id}}" [ngClass]="{'d-none': templateItem.showcc == false}">
                          <div id="costCenter" class="required-msg hide">Required</div>
                          <input type="text"
                                 title=""
                                 data-field="costCenter"
                                 value=""
                                 maxlength="100"
                                 name="costCenter"
                                 [(ngModel)]="templateItem.costCenter"
                                 class="form-control cost-center-input-el"
                                 (change)="saveOnChange(templateItem)" />
                          <!--/input>-->
                        </div>
                      </div>
                    </div>
                  </td>

                  <td class="col-md-2">
                    <div class="input-group" style="margin:10px -11px 1px -21px;">                     

                      <glaccount-template name="glAccount_{{templateItem.id}}"
                                          id="{{templateItem.id}}"
                                          placeHolder="GL Account"
                                          nbcClass="form-control gl-account-typeaheadtransaction numbers-only"
                                          [(model)]="templateItem.glAccount"
                                          title="{{templateItem.glAccount}}"
                                          typeaheadOptionLimit="10"
                                          nbcAuthenticateUser="Timecard.GLAccount.Update"
                                          nbcAuthenticateCommand="disabled"
                                          nbcAuthenticateDisabled="expired">
                      </glaccount-template>

                    </div>
                  </td>
                  <td>
                    <div class="input-group float-end" style=" margin-top: 14px;">
                      <button authenticate-user="position.delete"
                              type="button" class="btn btn-icon-clear"
                              title="Delete"
                              (click)="deleteTemplateDetail(templateItem)"
                              [disabled]="disableClearButton">
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="templateslength==0">
                  <td colspan="6">No results</td>
                </tr>
              </tbody>

            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

